"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadCssFile = exports.isURL = exports.createScript = void 0;
var createScript = function (playerScript, document) {
    if (document === void 0) { document = window.document; }
    var promise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.onload = function () {
            resolve(playerScript);
        };
        script.onerror = function () {
            var err = "Error loading script: ".concat(playerScript);
            console.error(err);
            reject(err);
        };
        script.async = true;
        script.src = playerScript;
        document.getElementsByTagName('head')[0].appendChild(script);
    });
    return promise;
};
exports.createScript = createScript;
var isURL = function (input) {
    var url;
    try {
        url = new URL(input);
    }
    catch (_a) {
        return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
};
exports.isURL = isURL;
var loadCssFile = function (path, token) {
    var cssId = "jw-custom-skin";
    token && (cssId += token);
    if (!document.getElementById(cssId)) {
        var head = document.getElementsByTagName('head')[0];
        var link = document.createElement('link');
        link.id = cssId;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = path;
        link.media = 'all';
        head.appendChild(link);
    }
};
exports.loadCssFile = loadCssFile;
